import { Link } from 'react-router-dom';

import { Button } from '../components/Button';
import { Card } from '../components/Card';
import { EmptyState } from '../components/states';

export function NotFound() {
  return (
    <Card>
      <EmptyState title="Page not found" detail="That route does not exist in this dashboard." />
      <div className="flex justify-center">
        <Link to="/">
          <Button variant="primary" size="sm">
            Back to the dashboard
          </Button>
        </Link>
      </div>
    </Card>
  );
}
